// import UpModel from '../model/updownview';
// import consts from '../consts/const';
// export const GET_LIKE = 'GET_LIKE';
//
// export const  get_like = (postid) =>{
//   return async (dispatch,getState) =>{
//     const userid = getState().authReduse.id;
//     const res= await fetch(`http://${consts.url}/api/main/likes.php`,{
//        method:'POST',
//        headers:{'content-Type':'application/json'},
//        body:JSON.stringify({postid,userid})
//      });
//     const data =[];
//     const resses = await res.json();
//     const ress = resses[0];
//     const view = resses[1].dd;
//     console.log(ress,resses[1]);
//     for(const key in ress){
//     data.push(new UpModel(ress[key].typed,ress[key].userid,ress[key].postid))
//     }
//
// console.log(data)
//     dispatch({type:'GET_LIKE',data:data,view:view})
//   }
// }
import UpModel from '../model/updownview';

import CommentsModel from '../model/comments';
import PostModel from '../model/posts';
export const GET_COMM = 'GET_COMM';
export const GET_POST = 'GET_POST';
export const GET_LIKE = 'GET_LIKE';
export const MERGE_LIKES = 'MERGE_LIKES';
export const GET_LAV = 'GET_LAV';

export const get_my_likes = () => {
  return async (dispatch, getState) => {
    const {id, pid} = getState().authReduse || {};
    if (!id || !pid) return;
    const res = await fetch(`/api/vud/mine/${encodeURIComponent(id)}/${encodeURIComponent(pid)}`);
    if (!res.ok) return;
    const rows = await res.json();
    const data = (Array.isArray(rows) ? rows : []).map(row => new UpModel(row.type, row.userid, row.postid));
    try {
      const votes = JSON.parse(localStorage.getItem('pinweelo-votes') || '{}');
      Object.keys(votes).forEach(key => {
        if (key.startsWith(`${id}:`)) delete votes[key];
      });
      data.forEach(row => {
        votes[`${id}:${row.postid}:${row.type}`] = true;
      });
      localStorage.setItem('pinweelo-votes', JSON.stringify(votes));
    } catch (err) {}
    dispatch({type: MERGE_LIKES, userid: id, data});
  }
};

const mapRecommendation = (item) => new PostModel(
  item.id, item.image, item.title, item.type, item.userid, item.tages,
  item.discrption || item.description, item.time, item.thumbnail,
  item.vCount, item.comm, item.pCount, item.dCount, item.userImg, item.email
);

export const get_recommendations = (postid) => async (dispatch, getState) => {
  const userid = getState().authReduse.id || '';
  const res = await fetch(`/api/postAi/recommendations/${encodeURIComponent(postid)}?userid=${encodeURIComponent(userid)}`);
  if (!res.ok) throw new Error('Could not load recommendations');
  const rows = await res.json();
  const data = (Array.isArray(rows) ? rows : []).map(mapRecommendation);
  dispatch({type: GET_LAV, data});
};

export const fetchRelatedPhotos = (postid, excludeIds = []) => async (dispatch, getState) => {
  const userid = getState().authReduse.id || '';
  const exclude = (excludeIds || []).map(id => String(id)).filter(Boolean).slice(0, 80).join(',');
  const query = new URLSearchParams({
    userid,
    type: 'i',
    shuffle: '1',
    limit: '12'
  });
  if (exclude) query.set('exclude', exclude);
  const res = await fetch(`/api/postAi/recommendations/${encodeURIComponent(postid)}?${query.toString()}`);
  if (!res.ok) throw new Error('Could not load related posts');
  const rows = await res.json();
  return (Array.isArray(rows) ? rows : []).map(mapRecommendation);
};

export const  get_lav = (postTages) =>{

  return async (dispatch,getState) =>{
    const userid = getState().authReduse.id;
    if (!postTages) return;
    const res= await fetch(`/api/posts/lav/${encodeURIComponent(postTages)}`);
    const data =[];
    const data2 =[];
    const data3 = [];

    const resses = await res.json();
    const recommendationRows = Array.isArray(resses)
      ? resses
      : (resses.msg || resses.msg4 || resses.data || []);
  // console.log(resses)
    for(const key in recommendationRows){
    const recommendation = recommendationRows[key];
    data3.push(new PostModel(recommendation.id || recommendation.postid, recommendation.image, recommendation.title, recommendation.type, recommendation.userid, recommendation.tages, recommendation.description || recommendation.disc || recommendation.discrption, recommendation.date || recommendation.time, recommendation.thumbnail, recommendation.views || recommendation.vCount, recommendation.vcomments || recommendation.comm, recommendation.vlikes || recommendation.pCount, recommendation.vdislikes || recommendation.dCount, recommendation.userImg, recommendation.email))
    }
    // console.log(data,data2,data3)

    // console.log(resses,post)
dispatch({type:'GET_LAV',data:data3});
console.log(data3,resses)

  }
}

export const  get_post = (postid) =>{

  return async (dispatch,getState) =>{
    const userid = getState().authReduse.id;
    const res= await fetch(`/api/postAi/postDeatils/${postid}${userid ? `?userid=${userid}` : ''}`);
    const data =[];
    const data2 =[];
    const data3 = [];

    const resses = await res.json();

    const ress = resses.msg4;
    const view = resses.msg2;
    const comments = resses.msg3;
    const post = resses.msg;
    // console.log(resses)
    for(const key in ress){
    data.push(new UpModel(ress[key].type,ress[key].userid,ress[key].postid))
  }

    for(const key in resses.msg){
    const row = resses.msg[key];
    data3.push(new PostModel(row.id,row.image || row.content,row.title,row.type,row.userid,row.tages,row.discrption || row.disc || row.description,row.time,row.thumbnail,row.vCount,row.comm,row.pCount,row.dCount,row.userImg,row.email,row.userLink,row.vleading))
    }

    for(const key in comments){
    const parentId = comments[key].parent_id || comments[key].parentId || null
    data2.push(new CommentsModel(comments[key].id,comments[key].content,comments[key].postid,comments[key].userid,comments[key].time,comments[key].img,comments[key].email,comments[key].dCount,comments[key].pCount,parentId,comments[key].userVote,comments[key].media))
    }
    console.log(data,data2,data3)
    console.log(data2,comments,resses)
    // console.log(resses,post)
dispatch({type:'GET_POST',data:data3});
dispatch({type:'GET_COMM',data:data2}) ;
dispatch({type:'GET_LIKE',data:data,view:view});

  }
}


// export const  get_postbytitle = (videotitle) =>{
//
//   return async (dispatch,getState) =>{
//     const userid = getState().authReduse.id;
//     const res= await fetch(`/api/postAi/postDeatilss/${videotitle}`);
//     const data =[];
//     const data2 =[];
//     const data3 = [];
//
//     const resses = await res.json();
//
//     const ress = resses.msg4;
//     const view = resses.msg2;
//     const comments = resses.msg3;
//     const post = resses.msg;
//     // console.log(resses)
//     for(const key in ress){
//     data.push(new UpModel(ress[key].type,ress[key].userid,ress[key].postid))
//   }
//
//     for(const key in resses.msg){
//     data3.push(new PostModel(resses.msg[key].id,resses.msg[key].image,resses.msg[key].title,resses.msg[key].type,resses.msg[key].userid,resses.msg[key].tages,resses.msg[key].discrption,resses.msg[key].time,null,null,null,null,null,resses.msg[key].userImg,resses.msg[key].email))
//     }
//
//     for(const key in comments){
//     data2.push(new CommentsModel(comments[key].id,comments[key].content,comments[key].postid,comments[key].userid,comments[key].time,comments[key].img,comments[key].email,comments[key].dCount,comments[key].pCount))
//     }
//     // console.log(data,data2,data3)
//     console.log(data2,comments,resses)
//     console.log(resses,post)
// dispatch({type:'GET_POST',data:data3});
// dispatch({type:'GET_COMM',data:data2}) ;
// dispatch({type:'GET_LIKE',data:data,view:view});
//
//   }
// }
